import { createContext, useContext } from "react";
import type { FluidPayApi } from "./api-interface";

const FluidPayApiContext = createContext<FluidPayApi | null>(null);

export const FluidPayApiProvider = FluidPayApiContext.Provider;

export function useFluidPayApi(): FluidPayApi {
  const api = useContext(FluidPayApiContext);
  if (!api) {
    throw new Error(
      "useFluidPayApi must be used within a FluidPayCoreProvider",
    );
  }
  return api;
}
